// import {Neighborhood} from "../neighborhoods/types"

import { CustomerAddress } from '../../../services/types';
import { Product } from '../merchants/types';

/**
 * Action types
 * @TOGGLE_MODAL_O modal order
 * @TOGGLE_MODAL_F modal freight
 * @TOGGLE_MODAL_P modal product
 * @TOGGLE_MODAL_RM modal product read more
 * @TOGGLE_MODAL_T modal timetable
 * @TOGGLE_MODAL_C modal cart (mobile only)
 * @TOGGLE_ORDER_STEP modal order step
 * @TOGGLE_ORDER_COMPLETE state of order to modal
 * @TOGGLE_MODAL_I modal instructions of payment
 * @HANDLE_ADDRESSES handle addresses for freight modal
 */
export enum ModalsTypes {
  TOGGLE_MODAL_O = '@modal/TOGGLE_MODAL_O',
  TOGGLE_MODAL_P = '@modal/TOGGLE_MODAL_P',
  TOGGLE_MODAL_RM = '@modal/TOGGLE_MODAL_RM',
  TOGGLE_MODAL_F = '@modal/TOGGLE_MODAL_F',
  TOGGLE_MODAL_T = '@modal/TOGGLE_MODAL_T',
  TOGGLE_ORDER_STEP = '@modal/TOGGLE_ORDER_STEP',
  TOGGLE_ORDER_COMPLETE = '@modal/TOGGLE_ORDER_COMPLETE',
  TOGGLE_MODAL_C = '@modal/@TOGGLE_MODAL_C',
  TOGGLE_MODAL_I = '@modal/@TOGGLE_MODAL_I',
  HANDLE_ADDRESSES = '@modal/@HANDLE_ADDRESSES',
}

export interface OrderError {
  merchantId?: string[];
  email?: string[];
  productId?: string[];
  variationItemId?: string[];
  eSitef_CreditCard?: string[];
}

export interface StoredAddresses {
  availableAddresses: CustomerAddress[];
  unavailableAddresses: CustomerAddress[];
}
/**
 * State type
 * @data : the Address
 */
export interface ModalsState {
  statusO: boolean;
  statusP: boolean;
  statusRM: boolean;
  statusF: boolean;
  statusT: boolean;
  statusC: boolean;
  statusI: boolean;
  step: number;
  orderComplete: boolean;
  orderError: OrderError;
  orderId: string;
  orderReceipt?: string;
  orderPrepaid: boolean;
  product: Product;
  storedAddresses: StoredAddresses;
}
